<script lang="ts">
    import { intersectionObserver } from '@amp/web-app-components/src/actions/intersection-observer';
    import { getPageVisibilityStore } from '@amp/web-app-components/src/stores/pageVisibility';
    import { prefersReducedMotion as prefersReducedMotionStore } from '@amp/web-app-components/src/stores/prefers-reduced-motion';
    import { getPreconnectTracker } from './utils/preconnect';

    const preconnectTracker = getPreconnectTracker();

    export let forceAnimation: boolean = false;
    export let videoSrc: string;
    export let viewportThreshold: number | null = null;
    export let videoCover: boolean = false;
    export let isPaused = false;

    let isInViewport: boolean = false;
    let pageVisibilityStore = getPageVisibilityStore();

    $: prefersReducedMotion = prefersReducedMotionStore
        ? $prefersReducedMotionStore
        : false;
    $: isPageVisible = pageVisibilityStore ? $pageVisibilityStore : false;
    $: shouldPlay =
        forceAnimation ||
        (!!videoSrc &&
            !prefersReducedMotion &&
            isPageVisible &&
            isInViewport &&
            !isPaused);

    $: {
        preconnectTracker?.trackUrl(videoSrc);
    }

    const handleInViewportChange = (isIntersecting: boolean): void => {
        isInViewport = isIntersecting;
    };
</script>

<amp-ambient-video
    use:intersectionObserver={{
        callback: handleInViewportChange,
        threshold: viewportThreshold,
    }}
    class="editorial-video"
    class:editorial-video--cover={videoCover}
    src={videoSrc}
    playing={shouldPlay}
    data-playing={shouldPlay}
    data-testid="ambient-video-player"
    aria-hidden="true"
/>

<style lang="scss">
    @use '@amp/web-shared-styles/app/core/mixins/absolute-center' as *;

    .editorial-video {
        height: 100%;
        mask-image: radial-gradient(white, black);
        overflow: hidden;
        position: absolute;
        width: 100%;
        // Inherit `border-radius` from grandparent, which may vary (ex Superhero, product hero)
        border-radius: inherit;
        z-index: var(--z-default);

        :global(video) {
            height: var(--editorialVideoHeight, 100%);
            width: var(--editorialVideoWidth, auto);
            object-fit: cover;

            @include absolute-center(cropped);
        }
    }

    .editorial-video--cover {
        :global(video) {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: top;
            position: static;
        }
    }
</style>
